module.exports = __webpack_public_path__ + "img/icon-2.8309d3e6.png";